import React from "react";

const Close = ({ active }) => {
  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--primary")
    ?.trim();
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke={primaryColor}
        className="size-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18 18 6M6 6l12 12"
        />
      </svg>
    </div>
  );
};

export default Close;
